import { enviroment } from "../../enviroment";

// Admin perf FE-3 (flag REACT_APP_ADMIN_PERF_ADMIN_SWR_ENABLED): the admin
// screens' staleTime-0 queries are meant to "always show the current server
// state on entry" - but with the global refetchOnMount:false (index.tsx) a
// re-visit inside the 5 min cacheTime showed the OLD numbers with 0 calls,
// and a re-visit after it showed a full spinner (GC'd). With the flag on
// they paint at once from a 30 min cache and refetch ONCE in the background
// on every entry (stale-while-revalidate). keepPreviousData keeps the
// previous page/filter/date visible while the next one loads - EVERY screen
// that gets it must read isPreviousData and dim/aria-busy the old data
// (statistics, orders-queue, orders-today, ...; the order list already
// did), otherwise old numbers show under a new label with no hint. Spread
// LAST into the useQuery options; off = {} (byte-identical options).
// staleTime is never touched here.

const ADMIN_SWR_CACHE_TIME_MS = 30 * 60_000;

type AdminSwrOptions = {
  refetchOnMount?: true;
  cacheTime?: number;
  keepPreviousData?: true;
};

/** Singleton / detail keys: paint from cache + one background refetch. */
export function adminSwrOptions(): AdminSwrOptions {
  if (!enviroment.adminPerfAdminSwrEnabled) return {};
  return { refetchOnMount: true, cacheTime: ADMIN_SWR_CACHE_TIME_MS };
}

/** List / filter / date keys: as above + the previous key's data stays visible. */
export function adminSwrListOptions(): AdminSwrOptions {
  if (!enviroment.adminPerfAdminSwrEnabled) return {};
  return {
    refetchOnMount: true,
    cacheTime: ADMIN_SWR_CACHE_TIME_MS,
    keepPreviousData: true,
  };
}

/**
 * Statistics cards (staleTime 60 s stays): only keepPreviousData + the long
 * cacheTime, so a date-range change no longer blanks the cards.
 */
export function adminSwrStatisticsOptions(): AdminSwrOptions {
  if (!enviroment.adminPerfAdminSwrEnabled) return {};
  return { cacheTime: ADMIN_SWR_CACHE_TIME_MS, keepPreviousData: true };
}
